import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, take, switchMap, of } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RegisterGuardService {

  constructor(
    private authService: AuthService,
    private router: Router) { }

  canActivate(
    route: import("@angular/router").ActivatedRouteSnapshot,
    state: import("@angular/router").RouterStateSnapshot): boolean | import("@angular/router").UrlTree | import("rxjs").Observable<boolean | import("@angular/router").UrlTree> | Promise<boolean | import("@angular/router").UrlTree> {
    return this.canActivateChild(route, state)
  }

  canActivateChild(
    route: import("@angular/router").ActivatedRouteSnapshot,
    state: import("@angular/router").RouterStateSnapshot): Observable<boolean> {

    const obs = this.authService.user$.pipe(take(1))
    return obs.pipe(
      switchMap((user: any) => {
        if(user) {
          this.router.navigate(['/cockpit'])
        }
        return !user ? of(true) : of(false)
      })
    )
  }
}